import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Layer, ResponsePayload } from "@/types";
import { fetchPlaceLayers } from "./thunk";
import { parseMetaData } from "@/helpers/places/parse-metadata";

export interface PlaceLayersState {
  layers: Layer[];
  status: "idle" | "fetching";
  error: string | null;
}

const initialState: PlaceLayersState = {
  layers: [],
  status: "idle",
  error: ""
};

export const placeLayersSlice = createSlice({
  name: "placeLayers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[placeLayersSlice.name]
      }))
      .addCase(fetchPlaceLayers.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchPlaceLayers.fulfilled, (state, action) => {
        state.layers = action.payload
          ? parseMetaData(action.payload).sort(
              (a, b) => a.sequence - b.sequence
            )
          : [];
        state.status = "idle";
      })
      .addCase(fetchPlaceLayers.rejected, (state, action) => {
        const { statusText } = action.payload as ResponsePayload;

        state.status = "idle";
        state.error = statusText;
      });
  }
});
